import { useEffect, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSession } from '@/api/auth';
import { setSessionExpiredHandler } from '@/api/client';
import { useAuthStore } from '@/stores/auth-store';
import { toast } from '@/components/ui';
import { t } from '@/i18n';

/**
 * Uygulama açılışında `/auth/me` ile oturumu geri yükler ve
 * axios'un "oturum düştü" geri çağrısını bağlar.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  useSession();

  const clearSession = useAuthStore((state) => state.clearSession);
  const queryClient = useQueryClient();

  useEffect(() => {
    setSessionExpiredHandler(() => {
      // Zaten oturumsuzsak kullanıcıyı gereksiz uyarıyla rahatsız etme.
      if (useAuthStore.getState().user === null) return;
      clearSession();
      queryClient.clear();
      toast.error(t('errors.sessionExpired'));
    });
  }, [clearSession, queryClient]);

  return <>{children}</>;
}
